(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    var bar = document.querySelector('.announcement-bar');
    if (!bar) return;
    var btn = bar.querySelector('.announcement-bar__dismiss');
    if (!btn) return;
    btn.addEventListener('click', function () {
      try { sessionStorage.setItem('voitkus_announcement_dismissed', '1'); } catch (e) {}
      document.documentElement.classList.add('is-announcement-dismissed');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    const a = e.target.closest('[data-voitkus-checkout]');
    if (!a) return;
    e.preventDefault();
    var href = a.getAttribute('data-checkout-href') || '/checkout';
    if (typeof window.voitkusRequirePaczkomat === 'function') {
      if (!window.voitkusRequirePaczkomat(href)) window.top.location.assign(href);
      return;
    }
    window.__voitkusPendingCheckout = href;
  }, true);

  const form = document.getElementById('cart-form');
  if (form) {
    form.querySelectorAll('[data-qty-btn]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        const input = document.getElementById(btn.getAttribute('data-qty-for'));
        if (!input) return;
        const step = Number(btn.getAttribute('data-qty-btn'));
        const min = Number(input.min || 1);
        const max = input.max === '' ? Infinity : Number(input.max);
        const next = Math.max(min, Math.min(max, Number(input.value || 1) + step));
        if (next === Number(input.value)) return;
        input.value = String(next);
        form.requestSubmit();
      });
    });
    form.querySelectorAll('[data-qty-input]').forEach((input) => {
      input.addEventListener('change', () => {
        const min = Number(input.min || 1);
        const max = input.max === '' ? Infinity : Number(input.max);
        input.value = String(Math.max(min, Math.min(max, Number(input.value || 1))));
        form.requestSubmit();
      });
    });
  }

  const coupon = document.getElementById('cart-coupon');
  if (coupon) {
    coupon.addEventListener('submit', (event) => {
      event.preventDefault();
      const input = coupon.querySelector('[name="discount"]');
      const code = input && input.value.trim();
      if (!code) return;
      window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=/cart');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-consent"]) return;
  try {
    
  (function () {
    var banner = document.getElementById('voitkus-cookie-banner');
    if (!banner) return;
    var storageKey = banner.getAttribute('data-storage-key') || 'voitkus_cookie_consent_v1';
    var analyticsId = banner.getAttribute('data-analytics-id') || '';
    var marketingId = banner.getAttribute('data-marketing-id') || '';
    var settingsPanel = banner.querySelector('#voitkus-cookie-settings');
    var analyticsInput = banner.querySelector('#voitkus-cookie-analytics');
    var marketingInput = banner.querySelector('#voitkus-cookie-marketing');
    var saveBtn = banner.querySelector('[data-voitkus-cookie-action="save"]');
    var acceptBtn = banner.querySelector('[data-voitkus-cookie-action="accept"]');

    function readConsent() {
      try {
        var raw = localStorage.getItem(storageKey);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    }

    function writeConsent(consent) {
      var payload = {
        necessary: true,
        analytics: !!consent.analytics,
        marketing: !!consent.marketing,
        version: 1,
        updated: Date.now()
      };
      try {
        localStorage.setItem(storageKey, JSON.stringify(payload));
      } catch (e) { /* quota */ }
      document.dispatchEvent(new CustomEvent('voitkus:cookie-consent', { detail: payload }));
      if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
        Shopify.customerPrivacy.setTrackingConsent({
          analytics: payload.analytics,
          marketing: payload.marketing,
          preferences: false,
          sale_of_data: false
        }, function () {});
      }
      return payload;
    }

    function loadGa(id) {
      if (!id || window.voitkusGaLoaded) return;
      window.voitkusGaLoaded = true;
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
      window.gtag('config', id, { anonymize_ip: true });
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id);
      document.head.appendChild(s);
    }

    function loadMeta(id) {
      if (!id || window.voitkusMetaLoaded) return;
      window.voitkusMetaLoaded = true;
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', id);
      window.fbq('track', 'PageView');
    }

    function applyScripts(consent) {
      if (!consent) return;
      if (consent.analytics) loadGa(analyticsId);
      if (consent.marketing) loadMeta(marketingId);
    }

    function hideBanner() {
      banner.hidden = true;
      banner.classList.remove('is-open');
    }

    function showBanner() {
      banner.hidden = false;
      banner.classList.add('is-open');
    }

    function setSettingsOpen(isOpen) {
      if (!settingsPanel || !saveBtn || !acceptBtn) return;
      settingsPanel.hidden = !isOpen;
      saveBtn.hidden = !isOpen;
      acceptBtn.hidden = isOpen;
    }

    function persist(consent) {
      applyScripts(writeConsent(consent));
      hideBanner();
      setSettingsOpen(false);
    }

    banner.querySelector('[data-voitkus-cookie-action="settings"]')?.addEventListener('click', function () {
      setSettingsOpen(settingsPanel && settingsPanel.hidden);
    });
    acceptBtn?.addEventListener('click', function () {
      persist({ analytics: true, marketing: true });
    });
    banner.querySelector('[data-voitkus-cookie-action="reject"]')?.addEventListener('click', function () {
      persist({ analytics: false, marketing: false });
    });
    saveBtn?.addEventListener('click', function () {
      persist({
        analytics: analyticsInput ? analyticsInput.checked : false,
        marketing: marketingInput ? marketingInput.checked : false
      });
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-voitkus-cookie-preferences]');
      if (!trigger) return;
      event.preventDefault();
      var existing = readConsent();
      if (analyticsInput) analyticsInput.checked = !!(existing && existing.analytics);
      if (marketingInput) marketingInput.checked = !!(existing && existing.marketing);
      setSettingsOpen(true);
      showBanner();
    });

    function bootPrivacy(done) {
      if (!window.Shopify || !Shopify.loadFeatures) {
        done();
        return;
      }
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { done(); });
    }

    bootPrivacy(function () {
      var existing = readConsent();
      if (window.Shopify && Shopify.designMode) {
        showBanner();
        return;
      }
      if (existing) {
        applyScripts(existing);
        return;
      }
      showBanner();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["discovery"]) return;
  try {
    
  (function () {
    function padSlot(n) {
      return String(n).padStart(2, '0');
    }

    function initFaq(root) {
      root.querySelectorAll('[data-discovery-faq-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (panel) panel.hidden = open;
        });
      });
    }

    function initPicker(root) {
      var selects = Array.prototype.slice.call(root.querySelectorAll('[data-discovery-slot]'));
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-discovery-lot]'));
      var hint = root.querySelector('[data-discovery-picker-hint]');
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-discovery-atc]'));
      var slotCount = 3;
      var busy = false;

      if (selects.length === 0) return;

      function ids() {
        return selects.map(function (select) {
          return parseInt(select.value, 10) || 0;
        });
      }

      function isComplete() {
        var values = ids().filter(function (id) { return id > 0; });
        return values.length === slotCount && new Set(values).size === slotCount;
      }

      function syncDuplicates() {
        var values = ids();
        selects.forEach(function (select, index) {
          Array.prototype.forEach.call(select.options, function (opt) {
            var val = parseInt(opt.value, 10) || 0;
            if (!val) {
              opt.disabled = false;
              return;
            }
            opt.disabled = values.some(function (id, i) {
              return i !== index && id === val;
            });
          });
        });
      }

      function syncCards() {
        var values = ids();
        cards.forEach(function (card) {
          var id = parseInt(card.getAttribute('data-discovery-lot'), 10) || 0;
          var slot = values.indexOf(id);
          var selected = slot >= 0;
          card.classList.toggle('is-selected', selected);
          card.setAttribute('aria-pressed', selected ? 'true' : 'false');
          var num = card.querySelector('[data-discovery-lot-num]');
          if (num) num.textContent = selected ? padSlot(slot + 1) : '·';
        });
      }

      function lotMeta(id) {
        if (!id) return { country: '—', name: '', accent: '#D8D4CC', price: 0 };
        var card = root.querySelector('[data-discovery-lot="' + id + '"]');
        return {
          country: card ? card.getAttribute('data-discovery-country') || '—' : '—',
          name: card ? card.getAttribute('data-discovery-name') || '' : '',
          accent: card ? card.getAttribute('data-discovery-accent') || '#D8D4CC' : '#D8D4CC',
          price: card ? parseInt(card.getAttribute('data-discovery-price'), 10) || 0 : 0
        };
      }

      function syncSlots() {
        var values = ids();
        root.querySelectorAll('[data-discovery-ui-slot]').forEach(function (el) {
          var index = parseInt(el.getAttribute('data-discovery-ui-slot'), 10);
          var meta = lotMeta(values[index] || 0);
          var filled = (values[index] || 0) > 0;
          var countryEl = el.querySelector('[data-discovery-slot-country]');
          var nameEl = el.querySelector('[data-discovery-slot-name]');
          el.classList.toggle('is-filled', filled);
          el.classList.toggle('is-empty', !filled);
          el.style.setProperty('--discovery-slot-accent', filled ? meta.accent : 'transparent');
          if (countryEl) countryEl.textContent = filled ? meta.country : 'Wybierz kawę';
          if (nameEl) nameEl.textContent = filled ? meta.name : '';
          el.setAttribute(
            'aria-label',
            filled
              ? 'Zestaw, pozycja ' + (index + 1) + ': ' + meta.country + '. Kliknij, żeby zdjąć.'
              : 'Zestaw, pozycja ' + (index + 1) + ' pusta. Wybierz kawę z listy.'
          );
        });
      }

      function syncDock() {
        var filled = ids().filter(function (id) { return id > 0; }).length;
        var count = root.querySelector('[data-discovery-dock-count]');
        if (count) count.innerHTML = filled + ' / ' + slotCount + ' <span>różne kawy</span>';
      }

      function syncHero() {
        var values = ids();
        var labels = [];
        var accents = [];
        var i;
        for (i = 0; i < slotCount; i += 1) {
          var meta = lotMeta(values[i] || 0);
          labels.push(meta.country);
          accents.push(meta.accent);
        }
        root.querySelectorAll('[data-discovery-strip-col]').forEach(function (el, index) {
          el.style.background = accents[index] || '#D8D4CC';
        });
        root.querySelectorAll('[data-discovery-strip-label]').forEach(function (el, index) {
          el.textContent = labels[index] || '—';
        });
        root.querySelectorAll('[data-discovery-tasting-row]').forEach(function (row, index) {
          var country = row.querySelector('[data-discovery-tasting-country]');
          var swatch = row.querySelector('[data-discovery-tasting-swatch]');
          var filled = (values[index] || 0) > 0;
          var label = filled && labels[index] && labels[index] !== '—' ? labels[index] : 'Wybierz kawę';
          var accent = filled ? (accents[index] || '#D8D4CC') : '#D8D4CC';
          row.classList.toggle('is-on', filled);
          row.classList.toggle('is-off', !filled);
          row.style.setProperty('--ticket-accent', accent);
          if (country) country.textContent = label;
          if (swatch) swatch.style.background = accent;
        });
      }

      function syncButton() {
        var ok = isComplete();
        var filled = ids().filter(function (id) { return id > 0; });
        var hasDup = new Set(filled).size !== filled.length;
        buttons.forEach(function (button) {
          button.disabled = !ok || busy;
          button.setAttribute('aria-disabled', ok && !busy ? 'false' : 'true');
        });
        if (hint) hint.hidden = ok || (filled.length === 0 && !hasDup);
      }

      function sync() {
        syncDuplicates();
        syncCards();
        syncSlots();
        syncHero();
        syncDock();
        syncButton();
      }

      function assignLot(id) {
        var values = ids();
        var existing = values.indexOf(id);
        if (existing >= 0) {
          selects[existing].value = '';
          sync();
          return;
        }
        var empty = values.findIndex(function (value) { return value === 0; });
        if (empty >= 0) {
          selects[empty].value = String(id);
          sync();
          return;
        }
        if (hint) hint.hidden = false;
      }

      function addToCart() {
        if (!isComplete() || busy) return;
        var boxId = parseInt(root.getAttribute('data-discovery-box-id'), 10) || 0;
        if (!boxId) return;
        busy = true;
        syncButton();
        var values = ids().filter(function (id) { return id > 0; });
        var sklad = values.map(function (id) {
          var meta = lotMeta(id);
          var card = root.querySelector('[data-discovery-lot="' + id + '"]');
          var title = card ? card.getAttribute('data-discovery-title') || '' : '';
          return meta.country && meta.country !== '—' ? meta.country : (meta.name || title);
        }).join(' · ');
        var endpoint = root.getAttribute('data-cart-add') || '/cart/add.js';
        var cartUrl = root.getAttribute('data-cart-url') || '/cart';
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: boxId,
              quantity: 1,
              properties: {
                'Skład': sklad,
                '_lot_1': String(values[0]),
                '_lot_2': String(values[1]),
                '_lot_3': String(values[2])
              }
            }]
          })
        }).then(function (res) {
          if (!res.ok) throw new Error('add failed');
          window.location.href = cartUrl;
        }).catch(function () {
          busy = false;
          syncButton();
        });
      }

      selects.forEach(function (select) {
        select.addEventListener('change', function () {
          var current = parseInt(select.value, 10) || 0;
          var values = ids();
          if (current && values.filter(function (id) { return id === current; }).length > 1) {
            select.value = '';
          }
          sync();
        });
      });

      cards.forEach(function (card) {
        card.addEventListener('click', function (event) {
          if (event.target.closest('a')) return;
          var id = parseInt(card.getAttribute('data-discovery-lot'), 10) || 0;
          if (id) assignLot(id);
        });
        card.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          var id = parseInt(card.getAttribute('data-discovery-lot'), 10) || 0;
          if (id) assignLot(id);
        });
      });

      root.querySelectorAll('[data-discovery-ui-slot]').forEach(function (el) {
        el.addEventListener('click', function () {
          var index = parseInt(el.getAttribute('data-discovery-ui-slot'), 10);
          var values = ids();
          if (!selects[index] || !values[index]) {
            var catalog = root.querySelector('[data-discovery-pool]');
            if (catalog && catalog.scrollIntoView) {
              catalog.scrollIntoView({ block: 'start', behavior: 'smooth' });
            }
            return;
          }
          selects[index].value = '';
          sync();
        });
      });

      buttons.forEach(function (button) {
        button.addEventListener('click', addToCart);
      });

      sync();
    }

    function boot() {
      document.querySelectorAll('.discovery-product').forEach(function (root) {
        if (root.getAttribute('data-discovery-ready')) return;
        root.setAttribute('data-discovery-ready', '1');
        initFaq(root);
        initPicker(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function boot() {
      var header = document.querySelector('[data-component="site-header"]');
      if (!header || header.getAttribute('data-nav-ready')) return;
      header.setAttribute('data-nav-ready', '1');

    var headerInner = header.querySelector('.site-header__inner');
    var toggle = header.querySelector('.mobile-menu-toggle');
    var nav = document.getElementById('site-nav');
    var backdrop = document.querySelector('.mobile-nav-backdrop');
    if (!toggle || !nav || !backdrop || !headerInner) return;

    var openLabel = toggle.getAttribute('data-label-open') || 'Otwórz menu';
    var closeLabel = toggle.getAttribute('data-label-close') || 'Zamknij menu';
    var mobileQuery = window.matchMedia('(max-width: 900px)');
    var navHome = null;

    function isMobile() { return mobileQuery.matches; }

    function ensureNavHome() {
      if (!navHome) {
        navHome = document.createComment('voitkus-nav-home');
        nav.parentNode.insertBefore(navHome, nav);
      }
      return navHome;
    }

    function portalNavToBody() {
      if (nav.parentNode === document.body) return;
      ensureNavHome();
      document.body.appendChild(nav);
    }

    function restoreNavToHeader() {
      if (!navHome || nav.parentNode === headerInner) return;
      headerInner.insertBefore(nav, navHome.nextSibling);
    }

    function syncNavMount() {
      if (isMobile()) portalNavToBody();
      else restoreNavToHeader();
    }

    function setOpen(isOpen) {
      if (!isMobile()) return;
      document.body.classList.toggle('mobile-nav-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggle.setAttribute('aria-label', isOpen ? closeLabel : openLabel);
      nav.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      backdrop.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      if (isOpen) {
        var close = document.querySelector('.site-nav__close');
        if (close) close.focus();
      } else {
        toggle.focus();
      }
    }

    toggle.addEventListener('click', function () {
      setOpen(!document.body.classList.contains('mobile-nav-open'));
    });
    document.addEventListener('click', function (event) {
      if (event.target.closest('.site-nav__close') || event.target === backdrop) {
        setOpen(false);
      }
    });
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && document.body.classList.contains('mobile-nav-open')) {
        setOpen(false);
      }
    });
    mobileQuery.addEventListener('change', function () {
      setOpen(false);
      syncNavMount();
      if (!isMobile()) {
        nav.removeAttribute('aria-hidden');
        backdrop.setAttribute('aria-hidden', 'true');
      } else if (!document.body.classList.contains('mobile-nav-open')) {
        nav.setAttribute('aria-hidden', 'true');
        backdrop.setAttribute('aria-hidden', 'true');
      }
    });

    syncNavMount();
    if (isMobile()) {
      nav.setAttribute('aria-hidden', 'true');
      backdrop.setAttribute('aria-hidden', 'true');
    }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-voitkus-checkout]');
      if (!a) return;
      e.preventDefault();
      var href = a.getAttribute('data-checkout-href') || '/checkout';
      if (typeof window.voitkusRequirePaczkomat === 'function') {
        if (!window.voitkusRequirePaczkomat(href)) window.top.location.assign(href);
        return;
      }
      window.__voitkusPendingCheckout = href;
    }, true);

    var root = document.getElementById('voitkus-mini-cart');
    if (!root) return;
    var busy = false;
    var lastFocus = null;
    var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function $(sel, el) { return (el || document).querySelector(sel); }

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function visibleCartControl() {
      var nodes = document.querySelectorAll('[data-voitkus-mini-cart-open]');
      for (var i = 0; i < nodes.length; i++) {
        var rect = nodes[i].getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) return nodes[i];
      }
      return nodes[0] || null;
    }

    function flyTargetRect() {
      var control = visibleCartControl();
      if (!control) return null;
      var badge = control.querySelector('.cart-count');
      if (badge && !badge.hidden) {
        var badgeRect = badge.getBoundingClientRect();
        if (badgeRect.width > 0 && badgeRect.height > 0) return badgeRect;
      }
      return control.getBoundingClientRect();
    }

    function bumpCartUi() {
      if (prefersReducedMotion()) return;
      var control = visibleCartControl();
      var badge = control && control.querySelector('.cart-count');
      if (control) {
        control.classList.remove('is-cart-bump');
        requestAnimationFrame(function () { control.classList.add('is-cart-bump'); });
        window.setTimeout(function () { control.classList.remove('is-cart-bump'); }, 480);
      }
      if (badge) {
        badge.classList.remove('is-cart-pop');
        requestAnimationFrame(function () { badge.classList.add('is-cart-pop'); });
        window.setTimeout(function () { badge.classList.remove('is-cart-pop'); }, 420);
      }
    }

    function flyToCart(fromEl, qty) {
      if (prefersReducedMotion() || !fromEl) return;
      var targetRect = flyTargetRect();
      if (!targetRect) return;
      var fromRect = fromEl.getBoundingClientRect();
      var startX = fromRect.left + fromRect.width / 2;
      var startY = fromRect.top + fromRect.height / 2;
      var endX = targetRect.left + targetRect.width / 2;
      var endY = targetRect.top + targetRect.height / 2;
      var fly = document.createElement('span');
      fly.className = 'voitkus-atc-fly';
      fly.textContent = '+' + String(qty > 0 ? qty : 1);
      fly.setAttribute('aria-hidden', 'true');
      fly.style.transform = 'translate3d(' + startX + 'px, ' + startY + 'px, 0) translate(-50%, -50%) scale(1)';
      document.body.appendChild(fly);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          fly.style.transform = 'translate3d(' + endX + 'px, ' + endY + 'px, 0) translate(-50%, -50%) scale(0.72)';
          fly.style.opacity = '0';
        });
      });
      function cleanup(e) {
        if (e && e.propertyName && e.propertyName !== 'transform') return;
        fly.removeEventListener('transitionend', cleanup);
        fly.style.willChange = 'auto';
        if (fly.parentNode) fly.parentNode.removeChild(fly);
      }
      fly.addEventListener('transitionend', cleanup);
      window.setTimeout(cleanup, 900);
    }

    function addQuantity(form, submitter) {
      var qty = 1;
      if (submitter) {
        var attr = parseInt(submitter.getAttribute('data-quantity') || '', 10);
        if (attr > 0) qty = attr;
      }
      var input = form && form.querySelector('[name="quantity"]');
      if (input) {
        var value = parseInt(input.value, 10);
        if (value > 0) qty = value;
      }
      return qty;
    }

    window.voitkusAtcFly = function (fromEl, qty) {
      flyToCart(fromEl, qty || 1);
      bumpCartUi();
    };

    function openCart(notice) {
      lastFocus = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var n = $('#voitkus-mini-cart-notice', root);
      if (n) {
        if (typeof notice === 'string' && notice) {
          n.textContent = notice;
          n.hidden = false;
        } else {
          n.textContent = 'Dodano do koszyka';
          n.hidden = !notice;
        }
      }
      var close = $('.mini-cart__close', root);
      if (close) close.focus();
    }

    function closeCart() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      var n = $('#voitkus-mini-cart-notice', root);
      if (n) n.hidden = true;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function syncCounts(count) {
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.hidden = count < 1;
        el.textContent = String(count);
      });
    }

    function refresh(keepOpen, notice) {
      var id = root.getAttribute('data-section-id');
      if (!id) return Promise.resolve();
      return fetch(routes + '?sections=' + encodeURIComponent(id))
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var html = json[id];
          var wrap = root.closest('.shopify-section');
          if (!html || !wrap) return;
          wrap.outerHTML = html;
          root = document.getElementById('voitkus-mini-cart');
          if (keepOpen && root) openCart(notice);
        });
    }

    function changeQty(key, qty) {
      if (busy) return;
      busy = true;
      fetch(routes + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          if (!res.ok) {
            var msg = (res.data && (res.data.description || res.data.message)) || 'Brak wystarczającej ilości na stanie';
            return refresh(true, msg);
          }
          syncCounts(res.data.item_count || 0);
          return refresh(true, false);
        })
        .finally(function () { busy = false; });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-voitkus-mini-cart-open]')) {
        e.preventDefault();
        openCart(false);
        return;
      }
      if (!root) return;
      if (e.target.closest('.mini-cart__close') || e.target.closest('.mini-cart__backdrop')) {
        closeCart();
        return;
      }
      var remove = e.target.closest('.mini-cart-item__remove');
      var step = e.target.closest('[data-qty-delta]');
      var item = e.target.closest('.mini-cart-item');
      if (!item) return;
      var key = item.getAttribute('data-line-key');
      var valueEl = item.querySelector('.mini-cart-item__qty-value');
      var qty = valueEl ? parseInt(valueEl.textContent, 10) : 1;
      if (remove) {
        e.preventDefault();
        changeQty(key, 0);
        return;
      }
      if (step && step.classList.contains('qty-stepper__btn')) {
        if (step.disabled) return;
        var delta = parseInt(step.getAttribute('data-qty-delta'), 10) || 0;
        var next = Math.max(0, qty + delta);
        var cap = item.getAttribute('data-qty-max');
        if (cap !== null && cap !== '' && next > parseInt(cap, 10)) {
          openCart('Tylko ' + cap + ' szt. dostępne');
          return;
        }
        changeQty(key, next);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root && root.classList.contains('is-open')) closeCart();
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form || e.submitter && e.submitter.hasAttribute('data-skip-mini-cart')) return;
      e.preventDefault();
      if (busy) return;
      busy = true;
      var fromEl = e.submitter || form.querySelector('[type="submit"]') || form;
      fetch(routes + 'cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          if (!res.ok) {
            var msg = (res.data && (res.data.description || res.data.message)) || 'Brak wystarczającej ilości na stanie';
            return refresh(true, msg);
          }
          window.voitkusAtcFly(fromEl, addQuantity(form, e.submitter));
          return fetch(routes + 'cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              syncCounts(cart.item_count || 0);
              var wait = prefersReducedMotion() ? 0 : 420;
              return new Promise(function (resolve) {
                window.setTimeout(function () { resolve(refresh(true, true)); }, wait);
              });
            });
        })
        .finally(function () { busy = false; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parzenie"]) return;
  try {
    
  (function () {
    var root = document.querySelector('.brew-guides');
    if (!root) return;

    var outTitle = root.querySelector('#brew-guides-diag-out .brew-guides__diag-v');
    var outHint = root.querySelector('#brew-guides-diag-out .brew-guides__diag-h');
    var chips = root.querySelectorAll('.brew-guides__chip');
    var levers = root.querySelectorAll('[data-lever].brew-guides__lever');

    chips.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var lever = btn.getAttribute('data-lever') || '';
        chips.forEach(function (b) {
          b.classList.toggle('is-on', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        if (outTitle) outTitle.textContent = btn.getAttribute('data-title') || '';
        if (outHint) outHint.textContent = btn.getAttribute('data-hint') || '';
        levers.forEach(function (el) {
          el.classList.toggle('is-lit', lever !== '' && el.getAttribute('data-lever') === lever);
        });
        var target = lever ? root.querySelector('#lever-' + lever) : null;
        if (target && target.scrollIntoView) {
          target.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const gallery = document.querySelector('[data-product-gallery]');
  let setGalleryByImageId = null;
  if (gallery) {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const counter = gallery.querySelector('[data-gallery-counter]');
    const setIndex = (index) => {
      const thumb = thumbs[index];
      if (!main || !thumb) return;
      main.src = thumb.dataset.fullSrc;
      thumbs.forEach((btn, i) => {
        btn.classList.toggle('is-active', i === index);
        btn.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
      if (counter) counter.textContent = `${index + 1} / ${thumbs.length}`;
    };
    setGalleryByImageId = (imageId, imageUrl) => {
      if (imageId != null) {
        const i = thumbs.findIndex((btn) => String(btn.dataset.imageId) === String(imageId));
        if (i >= 0) {
          setIndex(i);
          return;
        }
      }
      if (imageUrl && main) main.src = imageUrl;
    };
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => setIndex(i)));
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => {
      const current = thumbs.findIndex((btn) => btn.classList.contains('is-active'));
      setIndex((current - 1 + thumbs.length) % thumbs.length);
    });
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => {
      const current = thumbs.findIndex((btn) => btn.classList.contains('is-active'));
      setIndex((current + 1) % thumbs.length);
    });
  }

  const form = document.getElementById('product-form');
  if (form) {
    const variants = JSON.parse(document.querySelector('[data-product-variants]').textContent);
    const cartQtys = JSON.parse(document.querySelector('[data-cart-qtys]').textContent);
    const idInput = form.querySelector('[data-variant-id]');
    const priceEls = document.querySelectorAll('[data-product-price]');
    const weightEl = document.querySelector('[data-product-weight]');
    const stockEl = document.querySelector('[data-product-stock]');
    const atc = form.querySelector('[data-atc]');
    const dock = form.querySelector('[data-product-dock]');
    const dockAtc = dock && dock.querySelector('[data-atc-dock]');
    const dockQtyInput = dock && dock.querySelector('[data-qty-dock-input]');
    const dockQtyPlus = dock && dock.querySelector('[data-qty-plus-dock]');
    const page = form.closest('.product-page');
    const optionSelects = [...form.querySelectorAll('[data-option-index]')];
    const qtyRoot = form.querySelector('[data-qty]');
    const qtyInput = qtyRoot?.querySelector('input');
    const qtyPlus = qtyRoot?.querySelector('[data-qty-plus]');
    const addMax = (variant) => {
      if (!variant || !variant.tracked) return Infinity;
      const inCart = Number(cartQtys[String(variant.id)] || 0);
      return Math.max(0, Number(variant.inventory) - inCart);
    };
    const applyQty = (variant) => {
      const max = addMax(variant);
      const finite = Number.isFinite(max);
      if (qtyInput) {
        if (finite) qtyInput.max = String(max);
        else qtyInput.removeAttribute('max');
        const next = Math.max(1, Math.min(finite ? Math.max(max, 1) : Infinity, Number(qtyInput.value || 1)));
        qtyInput.value = String(finite && max < 1 ? 1 : next);
      }
      if (qtyPlus) qtyPlus.disabled = finite && Number(qtyInput?.value || 1) >= max;
      if (dockQtyPlus) dockQtyPlus.disabled = finite && Number(qtyInput?.value || 1) >= max;
      if (dockQtyInput && qtyInput) dockQtyInput.value = qtyInput.value;
      const blocked = !variant.available || (finite && max < 1);
      if (atc) atc.disabled = blocked;
      if (dockAtc) dockAtc.disabled = blocked;
      if (stockEl) {
        const inCartMax = variant.available && finite && max < 1;
        stockEl.textContent = inCartMax
          ? 'Maksymalna ilość już w koszyku'
          : (variant.available ? 'Dostępna — wysyłka 24–48h' : 'Chwilowo niedostępna');
        stockEl.classList.toggle('product-page__stock--in', variant.available && !inCartMax);
        stockEl.classList.toggle('product-page__stock--out', !variant.available || inCartMax);
      }
    };
    const selectedValues = () => optionSelects.map((el) => el.value);
    const findVariant = (selected) =>
      variants.find((variant) => selected.every((value, i) => variant.options[i] === value));
    const currentVariant = () => {
      if (!optionSelects.length) {
        return variants.find((variant) => String(variant.id) === String(idInput.value)) || variants[0];
      }
      return findVariant(selectedValues()) || variants[0];
    };
    const syncOptionAvailability = () => {
      if (optionSelects.length < 2) return;
      optionSelects.forEach((select, optIndex) => {
        [...select.options].forEach((opt) => {
          const probe = selectedValues();
          probe[optIndex] = opt.value;
          opt.disabled = !findVariant(probe);
        });
        if (select.selectedOptions[0]?.disabled) {
          const fallback = [...select.options].find((o) => !o.disabled);
          if (fallback) select.value = fallback.value;
        }
      });
    };
    const syncVariant = () => {
      syncOptionAvailability();
      const match = currentVariant();
      if (!match) return;
      idInput.value = match.id;
      priceEls.forEach(function (el) { el.textContent = match.price; });
      if (weightEl) {
        weightEl.textContent = match.weight || '';
        weightEl.hidden = !match.weight;
      }
      applyQty(match);
      if (setGalleryByImageId) setGalleryByImageId(match.image_id, match.image);
    };
    optionSelects.forEach((el) => el.addEventListener('change', syncVariant));
    qtyRoot?.querySelectorAll('[data-qty-btn]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!qtyInput || btn.disabled) return;
        const max = addMax(currentVariant());
        const next = Number(qtyInput.value || 1) + Number(btn.dataset.qtyBtn);
        qtyInput.value = String(Math.max(1, Math.min(Number.isFinite(max) ? max : next, next)));
        applyQty(currentVariant());
      });
    });
    dock?.querySelectorAll('[data-qty-btn]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const twin = qtyRoot && qtyRoot.querySelector('[data-qty-btn="' + btn.getAttribute('data-qty-btn') + '"]');
        if (twin) twin.click();
      });
    });
    if (dock && atc) {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var mobileDock = window.matchMedia('(max-width: 900px)');
      var dockTick = false;
      var setDock = function (p) {
        if (p < 0) p = 0;
        else if (p > 1) p = 1;
        if (reduceMotion) p = p >= 0.5 ? 1 : 0;
        var eased = 1 - Math.pow(1 - p, 3);
        dock.style.setProperty('--dock-p', String(eased));
        var live = p > 0.78;
        dock.classList.toggle('is-live', live);
        dock.setAttribute('aria-hidden', live ? 'false' : 'true');
        if (page) page.classList.toggle('has-dock', p > 0.28);
      };
      var readDock = function () {
        if (mobileDock.matches) {
          setDock(window.scrollY / 180);
          return;
        }
        var bottom = atc.getBoundingClientRect().bottom;
        setDock(-bottom / 140);
      };
      var onDockScroll = function () {
        if (dockTick) return;
        dockTick = true;
        requestAnimationFrame(function () {
          dockTick = false;
          readDock();
        });
      };
      window.addEventListener('scroll', onDockScroll, { passive: true });
      window.addEventListener('resize', readDock);
      if (mobileDock.addEventListener) mobileDock.addEventListener('change', readDock);
      else mobileDock.addListener(readDock);
      readDock();
    }
    syncVariant();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signup-popup"]) return;
  try {
    
  (function () {
    var popup = document.getElementById('voitkus-signup-popup');
    if (!popup) return;
    var storageKey = popup.getAttribute('data-storage-key') || 'voitkus_signup_popup_dismissed';
    var delay = Number(popup.getAttribute('data-delay'));
    if (!Number.isFinite(delay) || delay < 0) delay = 900;
    var closeBtn = popup.querySelector('.signup-popup__close');
    var backdrop = popup.querySelector('.signup-popup__backdrop');
    var skipBtn = popup.querySelector('.signup-popup__skip');
    var cta = popup.querySelector('.signup-popup__cta');
    var lastFocus = null;
    var prevOverflow = '';

    function isDismissed() {
      try { return sessionStorage.getItem(storageKey) === '1'; } catch (e) { return false; }
    }
    function persistDismiss() {
      try { sessionStorage.setItem(storageKey, '1'); } catch (e) { /* ignore */ }
    }
    function openPopup() {
      lastFocus = document.activeElement;
      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      (cta || closeBtn)?.focus();
    }
    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = prevOverflow;
      persistDismiss();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    closeBtn?.addEventListener('click', closePopup);
    backdrop?.addEventListener('click', closePopup);
    skipBtn?.addEventListener('click', closePopup);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });

    if (window.Shopify && Shopify.designMode) {
      openPopup();
      return;
    }
    if (!isDismissed()) window.setTimeout(openPopup, delay);
  })();

  } catch(e) { console.error(e); }
})();
})();
